// extracted by mini-css-extract-plugin
export default {"generalTermsContent":"CkMApjvr8sWPiCbLJPE9"};